import { render, staticRenderFns } from "./NotificationCardNavbar.vue?vue&type=template&id=2d380f23&"
import script from "./NotificationCardNavbar.vue?vue&type=script&lang=js&"
export * from "./NotificationCardNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports